import React from "react";

const AcceptedVote = () => {
  return (
    <div className="accepted-modal modal">
      <div className="accepted-modal__content">
        <h1 className="accepted-modal__title">Ваш голос принят</h1>

        <p className="accepted-modal__subtitle">Благодарим за участие!</p>
      </div>
    </div>
  );
};

export default AcceptedVote;
